import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'

function userFunctions() {
  $('#offcanvasRight').on('click', '#deleteUser', function() {
    lockButton('#deleteUser')
    const id = $("#basic-information").find('form').attr('action').split('/').pop()
    $.getScript('/users/' + id + '/delete_modal')
      .then(() => unlockButton('#deleteUser'))
      .catch(err => handleErrors(err, '#deleteUser'))
  })

  $('#offcanvasRight').on('change', '#user_role', function(event) {
    if ($(this).val() != 'MYYJÄ') {
      $('#user_country').prop("disabled", true)
      $('#user_client_company_id').prop("disabled", true)
    } else {
      $('#user_country').prop("disabled", false)
      $('#user_client_company_id').prop("disabled", false)
    }

    if (['ADMIN', 'PP', 'PEM', 'PO'].includes($(this).val())) {
      $('#user_business_unit_ids').prop("disabled", false)
    } else {
      $('#user_business_unit_ids').prop("disabled", true)
    }

    const qcRoles = ['SUPER_ADMIN', 'ADMIN', 'PP', 'PEM', 'PO']
    $('#user_show_all_qc').prop("disabled", !qcRoles.includes($(this).val()))
  })

  $('#offcanvasRight').on('change', '#user_country', function(event) {
    $.getScript('/clients/' + $('#user_client_id').val() + '/client_companies?country=' + $(this).val())
  })
}

export { userFunctions }
